"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.combineRegExp = void 0;
const combineRegExp = (...patterns) => {
    const combinedPatterns = patterns.map(pattern => pattern.source).join('|');
    const flags = new Set(patterns.flatMap(pattern => [...pattern.flags]));
    return new RegExp(combinedPatterns, [...flags].join(''));
};
exports.combineRegExp = combineRegExp;
